import { IconMarket } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

export const marketModule: ModuleDefinition = {
  id: 'market',
  i18nNamespace: 'market',
  requires: { subject: 'market', action: 'read' },

  nav: {
    labelKey: 'market:nav',
    icon: IconMarket,
    to: 'market',
    group: 'trade',
    order: 20,
  },

  routes: [{ path: 'market', component: () => import('./MarketPage') }],

  commands: [
    {
      id: 'market.board',
      labelKey: 'market:title',
      groupKey: 'market:title',
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/market`),
    },
    {
      id: 'market.publish',
      labelKey: 'market:publish',
      groupKey: 'market:title',
      requires: { subject: 'price', action: 'update' },
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/market?publish=1`),
    },
  ],
};
